<template>
  <section>
    <b-row>
      <b-col>
        <b-form-radio-group
          id="btn-radios-1"
          v-model="selectedReport"
          :options="reportOptions"
          buttons
          @change="changeReport"
          name="radios-btn-default"
        />
      </b-col>
    </b-row>

    <br />

    <b-row>
      <b-col>
        <multiselect
          v-model="fieldsSelected"
          :options="fields"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecione Columna..."
          label="name"
          track-by="name"
          :preselect-first="true"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
            >{{ values.length }} opciones selecionadas</span>
          </template>
        </multiselect>
        <!-- <pre class="language-json"><code>{{ fieldsSelected  }}</code></pre> -->
      </b-col>

      <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="itemsExcel"
          worksheet="data"
          name="data.xls"
          :before-generate="startDownload"
        >Exportar</downloadExcel>
      </b-col>
    </b-row>

    <br />

    <b-row v-if="false">
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <b-table
              :selectable="true"
              :select-mode="'multi'"
              @row-selected="rowSelected"
              class="font-size-12"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :fields="fieldsSelected"
              :items="items"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template slot="selected" slot-scope="{ rowSelected }">
                <span v-if="rowSelected">✔</span>
              </template>
            </b-table>
            <nav>
              <b-pagination
                size="sm"
                :total-rows="items.length == null ? 0 : items.length"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Anterior"
                next-text="Siguiente"
              />
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-card :header="'Tabla con Filtros'">
      <b-table
        :items="filteredItems"
        :fields="fieldsSelected"
        :current-page="currentPage"
        :per-page="perPage"
        :selectable="true"
        :select-mode="'multi'"
        @row-selected="rowSelected"
        responsive
      >
        <template :slot="`HEAD_${ key }`" v-for="key in fieldKeys" slot-scope="data">
          <b :key="key">{{ data.label }}</b>
          <select
            class="form-control form-control-sm"
            @click.stop.prevent
            v-model="selectVal[key]"
            :key="key"
          >
            <option :value="undefined">Seleccionar...</option>
            <option :value="option" v-for="option in options[key]" :key="option">{{ option }}</option>
          </select>
        </template>
        <template slot="selected" slot-scope="{ rowSelected }">
          <span
            v-if="rowSelected"
            class="fa fa-check-square fa-lg text-muted text-center center-block"
          ></span>
          <span v-else class="fa fa-square fa-lg text-muted text-center center-block"></span>
        </template>
      </b-table>
      <nav v-if="filteredItems.length > 0">
        <b-pagination
          size="sm"
          :total-rows="filteredItems.length == null ? 0 : filteredItems.length"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Anterior"
          next-text="Siguiente"
        />
      </nav>
    </b-card>
  </section>
</template>

<script>
export default {
  props: {
    caption: {
      type: String,
      default: "Reportes",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys.forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      if (this.items[0] === undefined) return null;
      else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys)
      this.fieldKeys.forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      selectedReport: "customers",
      reportOptions: [
        { text: "Clientes", value: "customers" },
        { text: "Gestiones", value: "task_managements" },
        { text: "Reporte 3", value: "radio3" },
        { text: "Reporte 4", value: "radio4" },
      ],
      fieldsSelected: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      items: [],
      itemsExcel: [],
      fields: [],
      selected: [],
      selectVal: {},
    };
  },
  mounted() {
    this.changeReport(this.selectedReport);
  },
  methods: {
    changeReport(arg) {
      this.selectVal = {};
      switch (arg) {
        case "customers":
          this.fields = [
            { key: "selected", name: "Select", label: "Select" },
            { key: "business_name", name: "Empresa", label: "Empresa" },
            { key: "type_name", name: "Tipo persona", label: "Tipo persona" },
            {
              key: "identification_type_name",
              name: "TP identificación",
              label: "TP identificación",
            },
            {
              key: "identification",
              name: "# Documento",
              label: "# Documento",
            },
            { key: "check_digit", name: "DV", label: "DV" },
            { key: "ciiu_code", name: "Código CIIU", label: "Código CIIU" },
            { key: "billing_mail", name: "Fac. Mail", label: "Fac. Mail" },
            {
              key: "billing_phone",
              name: "Fac. Teléfono",
              label: "Fac. Teléfono",
            },
            {
              key: "billing_address",
              name: "Fac. Dirección",
              label: "Fac. Dirección",
            },
            {
              key: "billing_neighborhood",
              name: "Fac. Barrio",
              label: "Fac. Barrio",
            },
            {
              key: "billing_city_name",
              name: "Fac. Ciudad",
              label: "Fac. Ciudad",
            },
            {
              key: "billing_zone_name",
              name: "Fac. Departamento",
              label: "Fac. Departamento",
            },
            { key: "status_name", name: "Estado", label: "Estado" },
            { key: "source_name", name: "Obtenido", label: "Obtenido" },
            { key: "advance_name", name: "Avance", label: "Avance" },
            { key: "advance_level_name", name: "Nivel", label: "Nivel" },
            { key: "phone", name: "Teléfono", label: "Teléfono" },
            { key: "contact_name", name: "Contacto", label: "Contacto" },
            { key: "to_do", name: "To do", label: "To do" },
          ];

          /*this.selectVal = {
                business_name: undefined,
                type_name: undefined,
                identification_type_name: undefined,
                identification: undefined,

                check_digit: undefined,
                ciiu_code: undefined,
                billing_mail: undefined,
                billing_phone: undefined,
                billing_address: undefined,
                billing_neighborhood: undefined,
                billing_city_name: undefined,
                billing_zone_name: undefined,
                status_name: undefined,
                source_name: undefined,
                advance_name: undefined,
                advance_level_name: undefined,
                phone: undefined,
                contact_name: undefined,
                to_do: undefined                
              }*/

          this.getCustomers();
          break;
        case "task_managements":
          this.fields = [
            { key: "selected", name: "Select", label: "Select" },
            { key: "management", name: "Gestión", label: "Gestión" },
            { key: "date", name: "Fecha", label: "Fecha" },
            { key: "type_name", name: "Tipo", label: "Tipo" },
            { key: "minutes", name: "Tiempo(min)", label: "Tiempo(min)" },
            { key: "task_name", name: "Tarea", label: "Tarea" },
            { key: "created_at", name: "Creada", label: "Creada" },
          ];
          this.getTaskManagements();
          break;
      }

      this.fieldsSelected = this.fields;
    },
    getCustomers() {
      showLoader();
      let url = `${this.$urlApi}customers?token=${this.token}`;
      this.$http
        .get(url, { headers: { "Content-Type": "application/json" } })
        .then(
          function (response) {
            this.items = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getTaskManagements() {
      showLoader();
      this.$http
        .get(`${this.$urlApi}taskmanagements?token=${this.token}`, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.items = response.data.data;
            //console.log(response)
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    startDownload() {
      showLoader();
      var columns = Object.keys(this.items[0]);
      var fields = [];

      for (var l = 0; l < this.fieldsSelected.length; l++) {
        fields.push(this.fieldsSelected[l].key);
      }

      for (var i = 0; i < this.selected.length; i++) {
        // for (var i = 0; i < this.items.length; i++) {
        var item = this.selected[i]; // var item = this.items[i]

        for (var j = 0; j < columns.length; j++) {
          var column = columns[j];
          if (fields.includes(column) == false) {
            delete item[column];
          }
        }

        this.itemsExcel.push(item);
      }
      hideLoader();
    },
    rowSelected(items) {
      this.selected = items;
    },
  },
};
</script>